import { ErrorResource } from "../locales";

export const error: ErrorResource = {
    couldNotSave: "Det gick inte att spara",
    ohNoSomethingWentWrong: "Åh nej, något gick fel! :(",
    refreshAndTryAgain: "Uppdatera sidan och försök igen.",
    goToLogin: "Gå till inloggning",
};
